import React from "react";
import { func, shape } from "prop-types";
import * as i18nUtils from "util/i18n";
import Button from "pages/_components/Button";

// TODO BIBANK remove scss module insted of global classes
import styles from "./styles.module.scss";

const StatementItem = ({ statement, handleClick }) => {
    const { id, date } = statement;
    const year = date.split(" ")[0].split("-")[0];
    const month = date.split(" ")[0].split("-")[1];
    const day = date.split(" ")[0].split("-")[2];

    return (
        <div className={`account-navigational-list-item-container ${styles.item}`}>
            <div>
                <Button image="images/figma/icon/download.svg" className="btn-link" onClick={() => handleClick(id)} />
            </div>
            <span>{`${i18nUtils.getArray("accounts.statements.to")} ${day}/${month}/${year}`}</span>
        </div>
    );
};

StatementItem.propTypes = {
    statement: shape({}).isRequired,
    handleClick: func.isRequired,
};

export default StatementItem;
